import React, { useState, useEffect, useCallback } from "react";
import { profileDb } from "./../../db/dbClasses";
import { profileStorage } from "./../../storage/storageClasses";
import { useForm } from "react-hook-form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { capitalCase } from "change-case";
import FileUploadToStorage from "./../Miscellaneous/FileUploadToStorage";
import classNames from "classnames";
import { useAlert } from "react-alert";

const initialData = {
  first_name: "",
  last_name: "",
  office: "",
  position: "",
  university: "",
  telephone: "",
  email: [],
  department: "",
  photo: "",
  photo_navbar: "",
  cv_link: "",
  contact_description: "",
  contact_notes: "",
  office_door_photo: "",
  socials: {
    facebook: "",
    twitter: "",
    github: "",
    research_gate: "",
    google_scholar: "",
    linkedin: "",
  },
};

// Extra.
// textarea: [...textarea, "contact_description"]

const fieldsConfig = {
  textarea: ["description", "contact_notes"],
  fileInput: ["cv_link", "photo", "photo_navbar", "office_door_photo"],
  text: [
    "first_name",
    "last_name",
    "email",
    "office",
    "position",
    "university",
    "telephone",
    "department",
  ],
};

const Profile = () => {
  const alertTrigger = useAlert();
  // The data of the form.
  const [data, setData] = useState(initialData);
  // An intermediary storage for new file uploads.
  const [fileUploadData, setFileUploadData] = useState({});
  // The data to be inserted in the db.
  const [finalData, setFinalData] = useState(undefined);

  const { register, handleSubmit } = useForm();

  const getData = useCallback(async () => {
    let result = await profileDb.read();
    setData((data) => {
      return { ...data, ...result[0] };
    });
  }, []);

  useEffect(() => {
    getData();
  }, [getData]);

  useEffect(() => {
    if (finalData) {
      profileDb
        .update(finalData, data.id)
        .then(() => {
          setFileUploadData({});
          getData();
          alertTrigger.success("Saved successfully!");
        })
        .catch((err) => {
          alertTrigger.error("Error saving personal details.");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [finalData]);

  const handleUploadSuccess = (key) => {
    return (result) => {
      setFileUploadData({
        ...fileUploadData,
        [key]: result.length === 1 ? result[0] : result,
      });
    };
  };

  const handleReset = (e) => {
    setFileUploadData({});
    getData();
    alertTrigger.show("New changes have been reset.");
  };

  const onSubmit = (enteredData) => {
    setFinalData({ ...data, ...enteredData, ...fileUploadData });
  };
  return (
    <div className="mx-auto p-5">
      <form onSubmit={handleSubmit(onSubmit)} className="fw-b font-open-sans">
        <h3>Personal Details</h3>
        <Row>
          {fieldsConfig.text.map((k) => {
            return (
              <Col key={k} md={6} lg={4} xl={3}>
                <div className="form-group mb-2">
                  <label htmlFor={k} className="form-label">
                    {capitalCase(k)}
                  </label>
                  <input
                    className="form-control"
                    name={k}
                    type={"text"}
                    defaultValue={data[k]}
                    ref={register}
                  />
                </div>
              </Col>
            );
          })}
        </Row>
        <br />
        <h3>Socials</h3>
        <Row>
          {Object.keys({
            ...initialData.socials,
            ...data?.socials,
          }).map((k) => {
            return (
              <Col key={k} md={6} lg={4} xl={3}>
                <div className="form-group mb-2">
                  <label htmlFor={k} className="form-label">
                    {capitalCase(k)}
                  </label>
                  <input
                    className="form-control"
                    name={`socials.${k}`}
                    type={"text"}
                    defaultValue={data?.socials && data?.socials[k]}
                    ref={register}
                  />
                </div>
              </Col>
            );
          })}
        </Row>
        <br />
        <h3>File Uploads</h3>
        <Row>
          {fieldsConfig.fileInput.map((k) => {
            return (
              <Col key={k} lg={6} xl={4}>
                <FileUploadToStorage
                  folder={`file-${k}`}
                  storageInstance={profileStorage}
                  buttonLabel={capitalCase(k)}
                  onChange={handleUploadSuccess(k)}
                  outputFormat="array"
                  value={data[k]}
                />
              </Col>
            );
          })}
        </Row>
        <br />
        <h3>
          Long text (Hit <code>enter</code> twice for a new paragraph).
        </h3>
        {fieldsConfig.textarea.map((k) => (
          <Row key={k}>
            <Col>
              <div className="form-group d-flex align-items-start justify-content-center flex-column">
                <label htmlFor="description" className="form-label">
                  {capitalCase(k)}
                </label>
                <textarea
                  name={k}
                  rows={"auto"}
                  defaultValue={data[k]}
                  className="form-control"
                  style={{
                    whiteSpace: "pre-wrap",
                    width: "100%",
                    minHeight: "200px",
                    height: "auto",
                    padding: "10px",
                  }}
                  ref={register}
                />
              </div>
            </Col>
          </Row>
        ))}
        <div className="mt-4 d-flex align-items-center justify-content-around w-50 mx-auto">
          <button type="submit" className={classNames("btn", "btn-success")}>
            Save Profile
          </button>
          <button type="reset" className="btn btn-danger" onClick={handleReset}>
            Reset Profile
          </button>
        </div>
      </form>
    </div>
  );
};

export default Profile;
